module.exports = __webpack_public_path__ + "static/star-trek-console-7d94d90e4ad1fbb7a4711b081e780256.jpg";